import { render, staticRenderFns } from "./AlphabetResult.vue?vue&type=template&id=b23a857a&scoped=true"
import script from "./AlphabetResult.vue?vue&type=script&lang=js"
export * from "./AlphabetResult.vue?vue&type=script&lang=js"
import style0 from "./AlphabetResult.vue?vue&type=style&index=0&id=b23a857a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23a857a",
  null
  
)

export default component.exports